import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Button, PageEmptyState } from 'seagull';
import { Plus } from 'seagull/icons';
import { openInNewTabProps } from '~/constants';
import { useStore, useStoreActions } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { helpArticles } from '~/utils/helpArticles';
import { CommonServicesPage } from '../CommonServicesPage/CommonServicesPage';
import { bulkImportRoute, ColumnId } from '../CommonServicesPage/CommonServicesPage.utils';
import EmptyServices from '../emptyServices.svg';
const baseColumnDefs = [
    {
        width: [
            200,
            300
        ],
        sortable: true
    },
    {
        width: [
            200,
            400
        ],
        sortable: false
    },
    {
        width: 120,
        sortable: true
    },
    {
        width: 110,
        sortable: true
    }
];
const baseHeaderItems = [
    {
        value: 'Service name',
        id: ColumnId.Name
    },
    {
        value: 'Included Services',
        id: ColumnId.IncludedServices
    },
    {
        value: 'Occurrence',
        id: ColumnId.BillingOccurance
    },
    {
        value: 'Billing trigger',
        id: ColumnId.BillingTrigger
    }
];
export function BundlesPage() {
    const { fetchBundles } = useStoreActions();
    const importServicesLink = useStore(selectors.filterAvailableRoutes([
        bulkImportRoute('bundles')
    ]))[0];
    const renderHeaderActions = (param)=>{
        let { openBuilder } = param;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                importServicesLink && /*#__PURE__*/ _jsx(Button, {
                    skin: "primaryOutline",
                    as: Link,
                    to: importServicesLink.url,
                    children: importServicesLink.text
                }),
                /*#__PURE__*/ _jsx(Button, {
                    prefixIcon: /*#__PURE__*/ _jsx(Plus, {
                        size: 18
                    }),
                    testId: "bundles-page-create-btn",
                    onClick: ()=>openBuilder(),
                    children: "Create Bundle"
                })
            ]
        });
    };
    const renderEmptyState = (param)=>{
        let { openBuilder } = param;
        return /*#__PURE__*/ _jsx(PageEmptyState, {
            testId: "bundles-empty",
            illustration: /*#__PURE__*/ _jsx(EmptyServices, {}),
            title: "Elevate Your Offering with Bundles",
            message: "Group multiple services into a single-priced bundle.",
            actions: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        testId: "bundles-page-new-btn",
                        onClick: ()=>openBuilder(),
                        children: "Create Bundle"
                    }),
                    /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({}, openInNewTabProps), {
                        skin: "primaryOutline",
                        testId: "bundles-learn-more-btn",
                        as: "a",
                        href: helpArticles.bundles(),
                        children: "Learn more about Bundles"
                    }))
                ]
            })
        });
    };
    return /*#__PURE__*/ _jsx(CommonServicesPage, {
        title: "Bundles",
        columnDefs: baseColumnDefs,
        headerItems: baseHeaderItems,
        fetchMethod: fetchBundles,
        renderEmptyState: renderEmptyState,
        headerActions: renderHeaderActions,
        dataSelector: (state)=>state.bundles,
        bundlesMode: true
    });
}
